import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { useRootSelector } from "store/hooks";
import { AccountInfo } from "store/account/account-state";
import {
  activeAccountTypeConfig,
  selectedAccountInfo,
} from "store/account/account-selector";

import {
  AccountTypeConfiguration,
  FieldMappingConfiguration,
} from "store/config";

import classes from "./Expension.module.scss";
import { toCamelCase } from "utility";

const showValue = (
  accountInfo: AccountInfo,
  config: AccountTypeConfiguration,
  t: any,
  fieldMapping: FieldMappingConfiguration,
) => {
  if (fieldMapping.importedFieldName === null) {
    return "-";
  }
  const value = accountInfo[toCamelCase(fieldMapping.importedFieldName)];

  if (fieldMapping.importedFieldName.toLowerCase() === "accounttype") {
    return config.name;
  } else if (fieldMapping.format.toLowerCase() === "currency") {
    return t("common:currency_format", {
      value: !!value ? value : 0,
    });
  } else if (fieldMapping.format.toLowerCase() === "date") {
    return new Date(value).getFullYear() > 1900
      ? t("common:date_format", { value })
      : t("common:not_applicable");
  } else if (!value) {
    return "-";
  } else {
    return value;
  }
};

export const renderAccountDetailItems = (
  accountInfo: AccountInfo,
  t: any,
  config: AccountTypeConfiguration,
) => (
  <>
    {config.accountDetails.mappings.map((detailKey) => {
      if (
        !!config.fieldMappings[detailKey] &&
        config.fieldMappings[detailKey].isDisplayed
      ) {
        const detailItem = config.fieldMappings[detailKey];
        return (
          <div key={detailKey} className={classes.Detail_items}>
            <p className={classes.Items_head}>
              {detailItem.displayName.indexOf(":") > 0
                ? t(detailItem.displayName)
                : detailItem.displayName}
            </p>
            <p className={classes.Items_val}>
              {showValue(accountInfo, config, t, detailItem)}
            </p>
          </div>
        );
      } else {
        return <Fragment key={detailKey}></Fragment>;
      }
    })}
  </>
);

export const Expension: React.FC<{ tagLine?: string }> = ({ tagLine }) => {
  const accountInfo = useRootSelector(selectedAccountInfo);
  const config = useRootSelector(activeAccountTypeConfig);

  const { t } = useTranslation([
    "payment_next",
    "payment",
    "common",
    "quickpay",
    "account",
  ]);
  return (
    <ft-expansion noRipple open class={classes.Expension}>
      <span slot="title" className={classes.ExpansionTitle}>
        {t("account:account_details")}
      </span>
      {tagLine && tagLine !== "quickpay_expension_tagline" && (
        <p className={classes.TagLine}>{tagLine}</p>
      )}
      <div className={classes.Load_detail}>
        {accountInfo ? renderAccountDetailItems(accountInfo, t, config) : null}
      </div>
    </ft-expansion>
  );
};
